import { render, staticRenderFns } from "./BookingCheckoutComponent.vue?vue&type=template&id=5b8c815a&scoped=true"
import script from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"
export * from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8c815a",
  null
  
)

export default component.exports